import React, { useEffect, useState } from "react"

const useWindowResize = () => {
  const [width, setWidth] = useState(0)
  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth)
  }

  useEffect(() => {
    if (width === 0) {
      handleWindowSizeChange()
    }
    window.addEventListener("resize", handleWindowSizeChange)
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange)
    }
  }, [])

  return width <= 768
}

export default useWindowResize
